/**
 * Sunucu verisinin cache anahtarları TEK yerde tanımlanır.
 * Bu veriler Zustand'a kopyalanmaz — cache sahibi TanStack Query'dir.
 */
export const queryKeys = {
  settings: {
    public: ['settings', 'public'] as const,
    admin: (group?: string) => ['settings', 'admin', group ?? 'all'] as const,
  },
  auth: {
    me: ['auth', 'me'] as const,
  },
  paymentMethods: ['payment-methods'] as const,
  health: ['health'] as const,

  // Aşağıdaki alanlar ilgili fazlarda doldurulacaktır.
  products: {
    all: ['products'] as const,
    list: (filters: Record<string, unknown>) => ['products', 'list', filters] as const,
    detail: (slug: string) => ['products', 'detail', slug] as const,
  },
  categories: {
    all: ['categories'] as const,
    detail: (slug: string) => ['categories', 'detail', slug] as const,
  },
  collections: {
    all: ['collections'] as const,
    detail: (slug: string) => ['collections', 'detail', slug] as const,
  },
  cart: (sessionId: string) => ['cart', sessionId] as const,
  delivery: {
    zones: ['delivery', 'zones'] as const,
    availability: (params: Record<string, unknown>) =>
      ['delivery', 'availability', params] as const,
  },
  orders: {
    track: (orderNo: string) => ['orders', 'track', orderNo] as const,
    mine: ['orders', 'mine'] as const,
  },
  admin: {
    today: ['admin', 'today'] as const,
    orders: (filters: Record<string, unknown>) => ['admin', 'orders', filters] as const,
    order: (id: string) => ['admin', 'orders', id] as const,
  },
} as const;
